import Vue from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import commonMixin from "./utilities/mixins/commonMixin";
import "@/assets/style.scss";
import "@/assets/style.css";

// Import and register vue-inline-svg
import InlineSvg from "vue-inline-svg";
Vue.component("inline-svg", InlineSvg);

import axios from "axios";
import {
  initNotificationsForSession,
  getAndRegisterFcmToken,
  setVueRootInstance,
} from "@/services/notifications";

Vue.config.productionTip = false;

Vue.mixin(commonMixin);

// Create a flag to avoid multiple redirects
let isRedirecting = false;

// Set up a base instance of axios
const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use(
  (config) => {
    // Retrieve the token from localStorage, Vuex store, or other storage methods
    const user = localStorage.getItem("grocer_user");
    let selectedStoreId = "";
    if (
      store?.getters?.getSelectedStore ||
      Object.keys(store?.getters?.getSelectedStore).length
    ) {
      selectedStoreId = store?.getters?.getSelectedStore?.id;
    }

    if (user) {
      config.headers["Authorization"] = `Bearer ${JSON.parse(user).token}`;
      if (selectedStoreId) {
        config.headers["X-STORE-ID"] = selectedStoreId;
      }

      // config.headers['ngrok-skip-browser-warning'] = 'true';
    }
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Reset the redirection flag on successful response
    isRedirecting = false;
    return response;
  },
  (error) => {
    // Check if the response status is 401 (Unauthorized)
    if (error.response && error.response.status === 401) {
      // Only redirect if not already redirecting
      if (!isRedirecting) {
        isRedirecting = true; // Set the flag
        // Ensure the current route is not already the login page
        if (router.currentRoute.name !== "login") {
          // Clear any tokens or user data if necessary
          // localStorage.removeItem('authToken');
          // Redirect to the login page
          localStorage.removeItem("grocer_user");
          store.dispatch("logout");
          store.dispatch("clearVuexStore");

          router.push("/");
        }
      }
    } else if (error.response && error.response.status >= 400) {
      // Handle all other 4xx and 5xx errors by dispatching to store
      // This ensures consistent error handling for both $axios and apiRequest usage
      store.dispatch("handleSnackBar", error);
    }
    return Promise.reject(error); // Reject the promise to handle other errors
  }
);

Vue.prototype.$axios = axiosInstance;
export default axiosInstance;

const app = new Vue({
  vuetify,
  store,
  router,

  render: (h) => h(App),
}).$mount("#app");

// Set the Vue root instance for notification events
setVueRootInstance(app);

// Initialize notifications (service worker + foreground listener)
initNotificationsForSession();

// Register/unregister FCM tokens on auth changes
store.subscribe(async (mutation) => {
  if (mutation.type === "setUser") {
    await getAndRegisterFcmToken();
  }
});

// If user already logged (page refresh), ensure token is registered
if (store.getters.isAuthenticated) {
  getAndRegisterFcmToken();
}
